<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box">
        <div class="field">
          <label class="label">Nombre de la cobertura</label>
          <div class="control">
            <input class="input" type="text" placeholder="" id="name" v-model="mappingName">
          </div>
        </div>
        <div class="field">
          <label class="label">Descripción</label>
          <div class="control">
            <textarea class="textarea" placeholder="" id="description" v-model="mappingDescription"/>
          </div>
        </div>
        <div>
          <button @click="clickCancel" class="button is-danger mt-5 mb-5 mr-5">Cancelar</button>
          <button @click = "clickAccept" class="button is-success mt-5 mb-5">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogDisclaimer",
  props: {
    name: String,
    description: String,
  },
  data() {
    return {
      mappingName: "",
      mappingDescription: "",
    }
  },
  methods: {
    clickCancel: function () {
      this.$emit('close')
      // document.getElementById("name").value = "";
      // document.getElementById("description").value = "";
    },
    clickAccept: function() {
      this.$emit('accept', {name: this.mappingName, description: this.mappingDescription});
      // document.getElementById("name").value = "";
      // document.getElementById("description").value = "";
    }
  },
}
</script>

<style scoped>
</style>